import { Layer, LayerGroup } from "../types";

import Feature from "src/js/stores/user/Feature";
import { SITES_LAYER_ID } from "./layerIds";
import { SitesLayerType } from "../layer_types/SitesLayerType";

export const SITES_LAYER: Layer = {
  id: SITES_LAYER_ID,
  layerType: SitesLayerType,
  title: "Saved sites",
  collapsed: true,
  toggleable: true,
  group: LayerGroup.GENERAL,
  icon: "lt-layer-saved-sites",
  description: "Sites saved by you and your team",
  requiredFeatureAccess: [Feature.sitesLayer],
};
